import React from 'react'
import { motion } from "framer-motion";
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import PaymentsIcon from '@mui/icons-material/Payments';

export default function HomeService() {
      const container = {
        hidden: {},
        visible: {
            transition: {
                staggerChildren: 0.18,
                delayChildren: 0.2,
            },
        },
    };

    const fadeUp = {
        hidden: {
            opacity: 0,
            y: 30,
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut",
            },
        },
    };
    const cardHover = {
        y: -6,
        boxShadow: "0px 20px 40px rgba(0,255,255,0.08)",
        transition: { duration: 0.3 },
    };
      const list = [
        {
            icon: < PaymentsIcon />,
            title: 'Debt Funding',
            desc: "Comprehensive debt financing solutions designed to support business expansion, working capital management, project execution... ",
        },
        {
            icon: <RocketLaunchIcon />,
            title: "Equity Raising",
            desc: "Strategic equity fundraising solutions enabling businesses to raise growth capital while strengthening valuation and investor participation.",
        },
        {
            icon: <RocketLaunchIcon />,
            title: "Hybrid Finance",
            desc: "Flexible financing instruments combining the benefits of debt and equity to optimize capital structure and investor returns.",
        },
        {
            icon: <RocketLaunchIcon />,
            title: "Structured Finance",
            desc: "Advanced and tailor-made financial solutions structured around cash flows, assets, and transaction-specific requirements. ",
        },
        {
            icon: <RocketLaunchIcon />,
            title: "International Funding",
            desc: "Global capital access solutions helping businesses raise cross-border funding and international investments.",
        },
        {
            icon: <RocketLaunchIcon />,
            title: "Government Schemes",
            desc: "Government-supported funding and guarantee programs designed to promote MSMEs, startups, infrastructure, and manufacturing growth.",
        },
        {
            icon: <RocketLaunchIcon />,
            title: "New Age Funding",
            desc: "Modern and alternative financing solutions powered by innovation, technology, and evolving investment ecosystems.",
        },
        
    ];
  return (
   <section>
                <div className='max-w-7xl mx-auto py-20 gap-10'>
                    <p className="text-dark-gold uppercase font-semibold text-lg mb-2">Our Expertise</p>

                    <h2 className="text-2xl sm:text-2xl lg:text-xl text-navy leading-snug mb-4 font-medium">
                        YB Capital Markets enables clients to meet their strategic and business objectives through its complete bouquet of investment banking and corporate advisory services. </h2>
                    <motion.div
                        variants={container}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="grid grid-cols-2 lg:grid-cols-4 gap-5"
                    >
                        {list.map((list, index) => (
                            <motion.div
                                key={index}
                                variants={fadeUp}
                                whileHover={cardHover}
                                className="p-6 border border-gray-300 rounded-lg mt-5"
                            >
                                {/* <img src={list.icon} alt='one' width={35} height={35} /> */}
                                {/* <span className='p-3  bg-orange-100' style={{ borderRadius: '50%' }}>{list.icon}</span> */}
                                <h3 className="text-xl font-semibold mb-3 ">
                                    {list.title}
                                </h3>
                                <p className="text-gray-600 text-base">
                                    {list.desc}
                                </p>

                                <button className='text-dark-gold p-3 rounded-lg font-medium shadow-lg mt-3 hover: border border-opacity-70'>Know More</button>

                            </motion.div>
                        ))}
                    </motion.div>
                </div>
            </section>
  )
}
